import { render, staticRenderFns } from "./MoveMenu.vue?vue&type=template&id=2c9f1042&"
import script from "./MoveMenu.vue?vue&type=script&lang=js&"
export * from "./MoveMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoveMenu.vue"
export default component.exports